import { defineComponent as _defineComponent } from 'vue'
import type { CompanyExtractData } from '@/utils/format-edit/yagiChatBot'


export default /*#__PURE__*/_defineComponent({
  __name: 'YagiChatBotSystemBubble',
  props: {
    text: null,
    variant: null,
    skippedQuestions: null,
    editIndices: null,
    companyData: null,
    editableFields: null
  },
  emits: ["edit", "edit-fields"],
  setup(__props: any) {





return { __sfc: true, }
}

})